export const isInStock = (stock: number, inCartQuantity: number): boolean => {
    const hasMaxQuantityReached = stock <= inCartQuantity;

    return !!stock && !hasMaxQuantityReached;
};
